<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Documents</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Fleet Managers
                            </li>
                            <li class="breadcrumb-item active">Documents
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Fleet Manager's Documents</h4>
                </div>

                <div class="card-body">
                    <table id="recent-user-documents"
                           class="table table-responsive">
                        <thead>
                        <tr>
                            <th>S/N</th>
                            <th>Document Name</th>
                            <th style="width: 10px">Document</th>
                            <th>Status</th>
                            <th>Date Submitted</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(document, index) in documentRows" :key="document.type">
                                <td class="text-truncate">{{ index + 1 }}</td>
                                <td class="text-truncate">
                                    {{ document.name }}
                                    <span class="badge badge-secondary ml-1">{{ document.required ? 'Mandatory' : 'Optional' }}</span>
                                </td>
                                <td class="text-truncate" style="width: 10px">
                                    <a v-if="documents[document.type]" :href="documents[document.type]" target="_blank" rel="noopener noreferrer">
                                        View
                                    </a>
                                </td>
                                <td class="text-truncate">
                                    <span v-if="documents[document.type]" class="badge badge-glow"
                                          :class="documents.document_status[document.type] === 'approved' ? 'badge-success'
                                          : (documents.document_status[document.type] === 'pending' ? 'badge-warning' : 'badge-danger')">
                                        {{ documents.document_status[document.type] }}
                                    </span>
                                </td>
                                <td class="text-truncate">{{ documents[`${document.type}_submitted_at`] }}</td>
                                <td class="text-truncate">
                                    <a v-if="documents[document.type] && documents.document_status[document.type] !== 'approved'" href="#"
                                       @click.prevent="documentAction(document.type, documents.fleet_manager_id, 1)">
                                        <i class="feather icon-check"></i> approve
                                    </a>
                                    <span v-if="documents[document.type] && documents.document_status[document.type] !== 'rejected' && documents.document_status[document.type] !== 'approved'">|</span>
                                    <a v-if="documents[document.type] && documents.document_status[document.type] !== 'rejected'" href="#"
                                       @click.prevent="documentAction(document.type, documents.fleet_manager_id, 0)" class="text-danger">
                                        <i class="feather icon-edit"></i> reject
                                    </a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Fleet Manager'},
    props: ['documents'],
    name: "FleetManagerDocumentIndex",
    layout: Layout,

    data: () => ({
        isLoadingFilter: false,
        tableDataLoading: false,
    }),
    computed: {
        documentRows() {
            return [
                { type: 'nin', name: 'NIN', required: true },
                { type: 'lasrra', name: 'LASRRA', required: false },
            ];
        },
    },
    created() {
        //
    },
    methods: {
        documentAction(documentType, fleetManager, action) {
            console.log(documentType, fleetManager, action)
            this.$inertia.put(route('admin.fleet_managers.manage-documents', [fleetManager, documentType]),
                {status: action}, {
                    preserveScroll: true,
                    onSuccess: () => {
                        // const agentIndex = this.agent.findIndex(a => agent.id === a.id);
                        // this.agent[agentIndex].status = this.agent[agentIndex].status === 1 ? 0 : 1;
                    }
                });
        },
    }
}
</script>
